<template>
  <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
    <el-tabs v-model="activeName" class="w-full h-full" type="card">
      <el-tab-pane label="数据集" class="w-full h-full" name="first">
        <iframe
          class="w-full h-full"
          :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/dataset/index?token=Bearer ${token}`"
          frameborder="0"
        ></iframe>
      </el-tab-pane>
      <el-tab-pane label="数据视图" class="w-full h-full" name="second">
        <iframe
          class="w-full h-full"
          :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/chart/index?token=Bearer ${token}`"
          frameborder="0"
        ></iframe>
      </el-tab-pane>
    </el-tabs>
  </el-card>

  <!-- 开发环境 http://localhost:9528/#/chart/index -->
  <!-- 测试环境 :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/chart/index`" -->
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      token: Wiz.AuthHooks.GetToken(),
    }
  },
}
</script>
<style scoped lang="scss">

/deep/.el-tabs__content {
  height: calc(100% - 60px) !important;
}

</style>
